import { render, staticRenderFns } from "./CreativeDetails.vue?vue&type=template&id=bf234828&scoped=true&"
import script from "./CreativeDetails.vue?vue&type=script&lang=js&"
export * from "./CreativeDetails.vue?vue&type=script&lang=js&"
import style0 from "./CreativeDetails.vue?vue&type=style&index=0&id=bf234828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf234828",
  null
  
)

export default component.exports